export const WEARER_ROLE_ID = 6;
